import { DataVariants } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema } from "../../../Schema";

export const qualificationStatusOptions = [
  { value: "CHANGED_COMPONENT_ONLY", label: "Changed component only" },
  { value: "NA", label: "NA" },
  { value: "NOT_QUALIFIED", label: "Not qualified" },
  { value: "QUALIFIED", label: "Qualified" },
];

export const qualificationStatus: FieldSchema = {
  name: "qualificationStatus",
  grid: {
    displayed: true,
    order: 25,
  },
  data: {
    variant: DataVariants.ENUM,
    options: qualificationStatusOptions,
    assignedValue: {
      getter: ({
        qualificationStatus,
        controlledEquipmentStatus,
        gxpRelevant,
      }) => {
        if (qualificationStatus === EMPTY_VALUE && gxpRelevant === "No") {
          return "NA";
        } else {
          if (
            !!controlledEquipmentStatus &&
            controlledEquipmentStatus !== "NA"
          ) {
            return "NA";
          }
        }
        return undefined;
      },
      fields: ["gxpRelevant", "controlledEquipmentStatus"],
    },
  },
  display: {
    displayed: true,
  },
  validation: {
    required: {
      getter: ({ controlledEquipmentStatus }) =>
        !controlledEquipmentStatus || controlledEquipmentStatus === "NA",
      fields: ["controlledEquipmentStatus"],
    },
  },
  form: {
    label: "Qualification status",
    type: InputTypes.SELECT,
    disabled: {
      getter: ({ controlledEquipmentStatus }) =>
        !!controlledEquipmentStatus && controlledEquipmentStatus !== "NA",
      fields: ["controlledEquipmentStatus"],
    },
  },
};
